import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderTop: '1px solid gray',
    marginTop: 40,
    paddingTop: 30
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
